var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    {},
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c("plotly", {
            attrs: { data: _vm.ofpPlotData, layout: _vm.plotLayout },
          }),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _c("v-text-field", {
                attrs: { dense: "", "persistent-hint": "", type: "number" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_c("p", [_vm._v("a")])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.a,
                  callback: function ($$v) {
                    _vm.a = $$v
                  },
                  expression: "a",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _c("v-text-field", {
                attrs: { dense: "", "persistent-hint": "", type: "number" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_c("p", [_vm._v("n"), _c("sub", [_vm._v("o")])])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.no,
                  callback: function ($$v) {
                    _vm.no = $$v
                  },
                  expression: "no",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _c("v-text-field", {
                attrs: {
                  dense: "",
                  "persistent-hint": "",
                  type: "number",
                  label: "nw",
                },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_c("p", [_vm._v("n"), _c("sub", [_vm._v("w")])])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.nw,
                  callback: function ($$v) {
                    _vm.nw = $$v
                  },
                  expression: "nw",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }